import React from 'react';
import PropTypes from 'prop-types';

const TextMessage = ({ text }) =>
  text
    .split(/\n/)
    .map((str, index) => (
      <p key={`notification-detail-text-${String(index)}`}>
        {str}
      </p>));

TextMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TextMessage;
